export const label = 'font-medium block text-base font-body text-textMid';
export const stackedList = 'pb-180 bg-white';
export const fadButton = 'm-3 absolute bottom-14 right-0 z-10 px-3.5 py-2.5';
export const dialogContent = 'h-full overflow-y-hidden';
